//-------------------------------------------------------------------------------------------------------------------------------------
//-------------------------------------------- CUSTOM CODES BY ACOWEBS - ACO PRODUCT OPTIONS AND ADDONS -------------------------------
//-------------------------------------------------------------------------------------------------------------------------------------

// Codes For rendering form on Quick view modal 
document.addEventListener("DOMContentLoaded", () => {
  document.addEventListener('tcustomizer-custom-show-quick-view', e => {
      const quickViewModal = document.querySelector('.m-product-quickview');
      if(quickViewModal && window.aco_appMeta) {
          window.wcpaInit(false, false, false, quickViewModal);
      }
  }, {capture: true});
});